import MatchHeight from 'vanilla-js-match-height'

export default function Heights() {
	new MatchHeight('.js-post-heading')

	new MatchHeight('.js-banner-heading')
	new MatchHeight('.js-banner-content')
	new MatchHeight('.js-banner-button')

	new MatchHeight('.js-card-title')
	new MatchHeight('.js-card-content')

	new MatchHeight('.js-statistic')

	new MatchHeight('.js-vacancy-item');
	new MatchHeight('.js-vacancy-heading');
	new MatchHeight('.js-vacancy-info');
	new MatchHeight('.js-vacancy-description');

	new MatchHeight('.js-search-title');
}
